import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { I18nService } from '../../services';

@Component({
  selector: 'app-confirm-remove-modal',
  templateUrl: './confirm-remove-modal.component.html',
  styleUrls: ['./confirm-remove-modal.component.scss'],
  standalone: false,
})
export class ConfirmRemoveModalComponent {
  @Input() showModal!: boolean;
  @Output() closeModal: EventEmitter<any> = new EventEmitter<any>();
  @Input() cartId!: string;

  private readonly router: Router = inject(Router);
  private readonly i18nService: I18nService = inject(I18nService);

  unShareCart(): void {
    this.closeModal.emit();
    this.router.navigate([this.i18nService.getCurrentLocale()]);
  }

  cancelDecline(): void {
    this.closeModal.emit();
  }
}
